export class CashFoundModel {
  public data: string;
  public importoAssegni: number;
  public importoContanti: number;
}
